import {
  CtaFooterRoot,
  CtaFooterContainer,
  ButtonWrapper,
  Title,
  Subtitle,
  IconWrapper,
  List,
} from './CtaFooter.styles'
import { Stack } from 'components/Stack'
import { Text } from 'components/Text'
import { useTranslation } from 'hooks/useTranslation'
import { Button } from 'components/Button'
import Link from 'next/link'
import { Icon } from 'components/Icon'
import { TranslationKeys } from 'locales/translationKeys'
import Trans from 'next-translate/Trans'

type CtaFooterProps = {
  title?: TranslationKeys
  subtitle?: TranslationKeys
  hideSecondaryCta?: boolean
  ctaLink?: string
  cta?: TranslationKeys
  list?: TranslationKeys[]
  children?: React.ReactNode
}

export const CtaFooter = (props: CtaFooterProps) => {
  const {
    title,
    subtitle,
    hideSecondaryCta = false,
    ctaLink = '/meal-plan',
    cta = 'common:cta-footer.CTA',
    list,
    children,
  } = props
  const { t } = useTranslation()

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  return (
    <CtaFooterRoot>
      <CtaFooterContainer hiddenSecondaryCta={hideSecondaryCta}>
        <IconWrapper>
          <Icon
            onClick={scrollToTop}
            size="7"
            css={{ cursor: 'pointer' }}
            name="arrow-circle-up"
            label={t('common:cta-footer.scrollTop')}
            color="accent-white"
          />
        </IconWrapper>
        {children}
        {title && (
          <Title
            as="h2"
            font="display"
            size={{ '@initial': 'h3', '@bp2': 'h1' }}
            color="accent-white"
          >
            <Trans i18nKey={title} components={{ br: <br /> }} />
          </Title>
        )}
        {subtitle && <Subtitle color="accent-white">{t(subtitle)}</Subtitle>}
        {list && (
          <List>
            {list.map((item) => (
              <li key={item}>{t(item)}</li>
            ))}
          </List>
        )}
        <ButtonWrapper>
          <Link passHref href={ctaLink}>
            <Button className="cta-footer cta">{t(cta)}</Button>
          </Link>
        </ButtonWrapper>
        {!hideSecondaryCta && (
          <Stack>
            <Text color="accent-white">{t('common:cta-footer.or')}</Text>
            <Link href="/products">
              <Text css={{ cursor: 'pointer' }} color="accent-white">
                {t('common:cta-footer.secondaryCTA')}
              </Text>
            </Link>
          </Stack>
        )}
      </CtaFooterContainer>
    </CtaFooterRoot>
  )
}

CtaFooter.displayName = 'CtaFooter'
